module.exports = __webpack_public_path__ + "images/feature/star-location-e63c54543098bdf14b8b0ae63acc062f.jpg";